import { RocketDuotone } from '@griply/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { Icon } from 'shared/components/ui/icon';

import { Faq } from '../faq';
import { Reviews } from '../reviews';
import * as Styled from './premium-layout.style';

export type PremiumLayoutProps = {
  card: React.ReactNode;
  onSkip: () => void;
};

export const PremiumLayout: React.FC<PremiumLayoutProps> = ({
  card,
  onSkip,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.OnboardingContainer>
      <Styled.Page>
        <Styled.Hero>
          <Styled.HeroIcon>
            <Icon icon={RocketDuotone} strokeWidth={2} />
          </Styled.HeroIcon>
          <Styled.HeroTitles>
            <Styled.HeroTitle>
              {t('forms.onboarding.premium.title')}
            </Styled.HeroTitle>
            <Styled.Subtitle>
              {t('forms.onboarding.premium.subtitle')}
            </Styled.Subtitle>
          </Styled.HeroTitles>
        </Styled.Hero>

        {card}

        <Button
          type="button"
          onClick={onSkip}
          variant={Variants.Text}
          size={Sizes.Medium}
          color={Colors.TextSecondary}
          alignCenter
        >
          {t('forms.onboarding.premium.continue-free')}
        </Button>

        <Reviews />

        <Faq />
      </Styled.Page>
    </Styled.OnboardingContainer>
  );
};
